module.exports = __webpack_public_path__ + "272574e5a7dda3bc8866bcddd693004c.fbx";